var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Reseller as ResellerModel } from '@/models/Reseller';
import PageHeader from '@/components/page-header/PageHeader';
import { fileToBase64, formatDate } from '@/support/String';
import DataTable from '@/components/data-table/DataTable';
import { Token } from '@/support/Token';
import ImageInput from '@/components/dialog/image-input/ImageInput';
import ErrorHandler from '@/support/ErrorHandler';
import { RolesEnum } from '@/items/Roles';
import ConfirmRemoveMfaDialog from '@/components/ConfirmRemoveMfaDialog/ConfirmRemoveMfaDialog.vue';
let Reseller = class Reseller extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Reseller';
        this.isEditing = false;
        this.isEditingDob = false;
        this.formatDob = formatDate;
        this.reseller = new ResellerModel();
        this.file = null;
        this.baseImage = null;
        this.isChangingAvatar = false;
        this.passwordHidden = true;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
        // #region RemoveMFA
        this.isConfirmRemoveMfaDialogOpen = false;
        // #endregion
    }
    get breadcrumbs() {
        return [{ name: this.$tc('roles.user', 2) }, { name: this.$tc('roles.reseller', 2), path: '/resellers' }, { name: this.reseller.name || '', path: this.$route.path }];
    }
    mounted() {
        new ResellerModel()
            .include('token')
            .find(this.$route.params.id)
            .then((reseller) => {
            this.reseller = reseller;
        });
    }
    update() {
        this.isEditing = false;
        if (this.password.new.length === 0) {
            this.resetPassword();
        }
        else {
            this.reseller.password = this.password.new;
        }
        const payload = this.reseller.getPayload();
        if (payload.avatar) {
            delete payload.avatar;
        }
        this.reseller
            .include(['reseller', 'roles'])
            .update(payload)
            .then((reseller) => {
            this.resetPassword();
            this.reseller = reseller;
            this.updateCurrentUser(reseller);
        });
    }
    resetPassword() {
        delete this.reseller.password;
        delete this.reseller.current_password;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
    }
    updateCurrentUser(reseller) {
        if (reseller.id === this.$store.state.Auth.id) {
            this.$store.dispatch('userAuthenticated', reseller);
        }
    }
    setToken() {
        Token.set(this.reseller.token.bearer);
        const url = `${window.location.protocol}//${window.location.host}`;
        window.location.href = url;
    }
    changeAvatar(event) {
        if (event.target === null || event.target.files === null || !event.target.files.length) {
            return;
        }
        this.file = event.target.files[0];
        fileToBase64(this.file).then((encodedFile) => {
            this.baseImage = encodedFile;
            this.isChangingAvatar = true;
        });
    }
    async changingCurrentAvatar() {
        const resellerWithDataObjects = await new ResellerModel()
            .include(['data_objects'])
            .find(this.$route.params.id);
        if (resellerWithDataObjects) {
            this.baseImage = resellerWithDataObjects.data_objects.avatar;
            this.isChangingAvatar = true;
        }
        // if (!this.reseller.avatar) {
        //   return;
        // }
        // const canvas = document.createElement('canvas');
        // const img = new Image();
        // const context = canvas.getContext('2d');
        // img.crossOrigin = 'Anonymous';
        // img.src = this.reseller.avatar;
        // if (!img) {
        //   return;
        // }
        // if (!context) {
        //   return;
        // }
        // img.onload = () => {
        //   canvas.width = img.width;
        //   canvas.height = img.height;
        //   context.drawImage(img, 0, 0, img.width, img.height);
        //   this.baseImage = canvas.toDataURL();
        //   this.isChangingAvatar = true;
        // };
    }
    avatarChanged(imageUrl) {
        this.reseller
            .include(['reseller', 'roles'])
            .update({ avatar: imageUrl })
            .then((reseller) => {
            this.reseller.avatar = imageUrl;
            this.updateCurrentUser(reseller);
            this.$emit('closed', false);
            this.isChangingAvatar = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER]);
    }
    get canRemoveMfa() {
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN]);
    }
    get removeMfaEnabled() {
        return !!this.reseller.has_mfa_token;
    }
    async removeMfa() {
        if (this.reseller) {
            const reseller = await this.reseller
                .update({ mfa_token: null })
                .catch((error) => {
                ErrorHandler.network(error);
                return null;
            });
            if (reseller) {
                this.$set(this.reseller, 'has_mfa_token', false);
            }
        }
        this.isConfirmRemoveMfaDialogOpen = false;
    }
};
Reseller = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            ImageInput,
            ConfirmRemoveMfaDialog,
        },
    })
], Reseller);
export default Reseller;
